import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Public Pages
import BlogListing from "@/pages/BlogListing";
import BlogDetail from "@/pages/BlogDetail";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminSetup from "@/pages/admin/AdminSetup";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminBlogEdit from "@/pages/admin/AdminBlogEdit";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminMenus from "@/pages/admin/AdminMenus";
import AdminSettings from "@/pages/admin/AdminSettings";

// Auth Context
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#6F42F0]"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<BlogListing />} />
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/category/:categorySlug" element={<BlogListing />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/setup" element={<AdminSetup />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/blogs" 
            element={
              <ProtectedRoute>
                <AdminBlogs />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/blogs/new" 
            element={
              <ProtectedRoute>
                <AdminBlogEdit />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/blogs/:id" 
            element={
              <ProtectedRoute>
                <AdminBlogEdit />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/categories" 
            element={
              <ProtectedRoute>
                <AdminCategories />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/menus" 
            element={
              <ProtectedRoute>
                <AdminMenus />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/settings" 
            element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            } 
          />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
